/**
 * Copyright 2018 Ambrosus Inc.
 * Email: tech@ambrosus.com
 */
import React, { lazy } from 'react';
import { Switch, Route, Redirect } from 'react-router';
import { lazyLoad } from './utils';
import Documentation from './containers/Documentation';
const Repos = lazy(() => import('./containers/Repos'));
// const Documentation = lazy(() => import('./containers/Documentation/Documentation'));

const Routes = () => {
    return (
        <>
            <Switch>
                <Route path='/' exact component={lazyLoad(Repos)} />
                {/* <Route path='/documentation' component={lazyLoad(Documentation)} /> */}
                <Route exact path='/documentation' component={Documentation} />
                <Redirect from='*' to='/' />
            </Switch>
        </>
    );
};

export default Routes;
